import { render, staticRenderFns } from "./Documentos.vue?vue&type=template&id=061f6f0d"
import script from "./Documentos.vue?vue&type=script&lang=js"
export * from "./Documentos.vue?vue&type=script&lang=js"
import style0 from "./Documentos.vue?vue&type=style&index=0&id=061f6f0d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports